import React from "react";
import { PenTool } from "lucide-react";

export function Logo({ className = "", onDark = false }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="thinkink-logo">
      <div className={`flex h-9 w-9 items-center justify-center rounded-xl ${onDark ? "bg-white/15" : "integrity-gradient"}`}>
        <PenTool className="h-5 w-5 text-white" strokeWidth={2.4} />
      </div>
      <span className={`font-display text-xl font-extrabold tracking-tight ${onDark ? "text-white" : "text-foreground"}`}>
        Think<span className={onDark ? "text-[#25D366]" : "text-[#0B5D3B] dark:text-[#25D366]"}>Ink</span>
      </span>
    </div>
  );
}
